export const FILTERS_TOGGLER_ID = "filters-toggler";
